module.exports = function() {
  return new Worker(__webpack_public_path__ + "52000bc7086003bd839f.worker.js");
};